import math from './math'
import { itemCostPrice, orderInfoFlow } from '@/service/getData'
import { numberMul } from '@/util/index'

export function DisplayOrderFee(order_info) {
    var displayFee = {
        item: 0,
        tax: 0,
        labor: 0,
        discount: 0,
        discount_value: 0,
        total: 0
    }


    let itemFee = 0
    let originalFee = 0

    order_info.devices.map(device => {
        device.items.map(qitem => {
            itemFee = math.add(itemFee, math.multiply(qitem.price, qitem.count))
            originalFee = math.add(originalFee, math.multiply(qitem.original_price, qitem.count))
        })
    })

    if (order_info.products) {
        order_info.products.map(product => {
            itemFee = math.add(itemFee, math.multiply(product.price, product.count))
            originalFee = math.add(originalFee, math.multiply(product.original_price, product.count))
        })
    }

    if (itemFee == 0) {
        return displayFee
    }

    originalFee = math.multiply(originalFee, 1.13)
    originalFee = math.add(originalFee, order_info.labor_fee)

    order_info.item = itemFee
    order_info.itemFee = math.toFixed(itemFee)
    order_info.labor_fee = parseFloat(order_info.labor_fee) || 0
    order_info.discount_value = parseFloat(order_info.discount_value) || 0

    displayFee.labor = order_info.labor_fee
    displayFee.item = math.toFixed(order_info.itemFee)
    displayFee.discount_value = order_info.discount_value
    // displayFee.discount = math.multiply(math.divide(displayFee.discount_value, originalFee), 100)
    displayFee.tax = math.toFixed(
        math.multiply(0.13, displayFee.item)
    )

    let total = math.add(
        displayFee.item,
        displayFee.tax
    )
    total = math.add(
        total,
        displayFee.labor
    )
    total = math.subtract(
        total,
        displayFee.discount_value
    )
    displayFee.total = math.toFixed(total)
    order_info.amount = displayFee.total
    displayFee.discount = math.multiply(math.divide(math.subtract(originalFee, total), originalFee), 100)
    order_info.discount = displayFee.discount.toString()
    return displayFee
}

export function ItemCostPrices(order_info, cb) {
    let items = []
    order_info.devices.map(device => {
        device.items.map(qitem => {
            items.push({
                id: qitem.item_id,
                price: qitem.price,
                count: qitem.count
            })
        })
    })

    order_info.products.map(product => {
        items.push({
            id: product.item_id,
            price: product.price,
            count: product.count
        })
    })

    if (items.length == 0) {
        cb(0)
        return
    }

    let itemIDs = items.map(item => {
        return item.id
    })

    itemCostPrice({
        items: itemIDs
    }).then(res => {
        if (res.code == 0) {
            let itemCostPrices = res.data.list
            let storePriceMap = {}
            itemCostPrices.map(sip => {
                storePriceMap[sip.item_id] = sip.price
            })

            let cost = 0
            items.map(item => {
                if (storePriceMap[item.id]) {
                    cost += numberMul(storePriceMap[item.id], item.count)
                } else {
                    cost += numberMul(item.price, item.count)
                }
            })
            cb(cost)
        } else {
            cb(0)
        }
    })
}

export function CalculateProfit(order_info, cb) {
    let amount = math.subtract(order_info.itemFee, order_info.discount_value)
    amount = math.add(amount, order_info.labor_fee)
    let profit = math.subtract(amount, parseFloat(order_info.item_cost))
    profit = math.subtract(profit, parseFloat(order_info.install_cost))
    profit = math.subtract(profit, parseFloat(order_info.other_cost))

    let profitRate = math.divide(profit, amount) * 100
    cb(math.show(profit), profitRate.toFixed(2))
}

export function AutoOrderInfoFlow(order_info, oils, cb) {
    if (
        order_info.devices.length == 0 &&
        order_info.products.length == 0
    ) {
        return
    }

    var orderInfo = JSON.parse(JSON.stringify(order_info))

    orderInfo.devices = orderInfo.devices.map(d => {
        let device = {}
        device.device_id = d.device_id
        device.customer_device_id = d.customer_device_id || d.id

        device.items = d.items
            .filter(item => {
                if (oils) {
                    return item.checked && item.count > 0
                } else {
                    return true
                }
            })
            .map(item => {
                item.price = parseFloat(item.price)
                return item
            })

        if (oils) {
            var oil
            for (let index = 0; index < oils.length; index++) {
                const element = oils[index]
                if (d.oilID == element.item_id) {
                    oil = element
                }
            }
            if (oil) {
                oil.count = d.oilCount
                oil.price = parseFloat(oil.price)
                device.items.push(oil)
            }
        }

        return device
    })

    var products = orderInfo.products
        .filter(product => {
            if (oils) {
                return product.checked && product.count > 0
            } else {
                return true
            }
        })
        .map(item => {
            item.price = parseFloat(item.price)
            return item
        })

    orderInfo.labor_fee = parseFloat(orderInfo.labor_fee) || 0
    orderInfo.discount = parseFloat(orderInfo.discount) || 0
    orderInfo.discount_value = parseFloat(orderInfo.discount_value) || 0
    orderInfo.item_cost = parseFloat(orderInfo.item_cost) || 0
    orderInfo.install_cost = parseFloat(orderInfo.install_cost) || 0
    orderInfo.other_cost = parseFloat(orderInfo.other_cost) || 0

    orderInfoFlow(orderInfo).then(res => {
        if (res.code == 0) {
            var orderInfoFlow = res.data

            if (orderInfoFlow.flow.id > 0) {
                let users = orderInfoFlow.flow.approver_users.map(u => {
                    return u.name
                })
                orderInfoFlow.users = users.join(' <i class="el-icon-right"></i> ')
            }
            cb(orderInfoFlow)
        }
    })
}